<div class="signUpboxBg mt-0">
  @if (!showCodeBox()) {
    <!-- Step 1: confirm email -->
    <div class="signUpbox verify-email-box">
      <button class="closebtn" (click)="close()" aria-label="Close">
        <img src="assets/images/closeIcon.svg" alt="" />
      </button>
      <div class="title mt-3">{{ title() }}</div>
      @if (description()) {
        <h6 class="mb-3">{{ description() }}</h6>
      } @else {
        <h6 class="mb-3">We'll send a one-time code to your email so we can confirm it's yours.</h6>
      }

      <div>
        <input type="email"
               class="form-control input-box"
               name="emailReadonly"
               [value]="email()"
               readonly
               aria-label="Your email address" />
      </div>

      <button [disabled]="sendingCode() || !email()"
              [class.disabled]="!email()"
              (click)="sendCode(false)"
              class="common-btn mt-4"
              type="button">
        @if (sendingCode()) {
          <img class="loading-img" src="assets/images/processing_white.svg" />
        } @else {
          Continue
        }
      </button>

      <p class="text-center">
        <a (click)="close()" class="cursor-pointer">Maybe Later</a>
      </p>
    </div>
  } @else {
    <!-- Step 2: enter code -->
    <div class="signUpbox verify-email-box">
      <button class="closebtn" (click)="close()" aria-label="Close">
        <img src="assets/images/closeIcon.svg" alt="" />
      </button>
      <div class="title mt-3">We just sent you an email</div>
      <h6 class="mb-4">
        Enter the verification code we sent to<br>
        {{ maskedEmail || 'your email' }}
      </h6>

      <form #form="ngForm">
        <div class="d-block">
          <input type="text"
                 class="form-control input-box"
                 name="verificationCode"
                 [ngModel]="verificationCode()"
                 (ngModelChange)="onCodeInput($event)"
                 #codeRef="ngModel"
                 placeholder="Enter Code"
                 required
                 minlength="6"
                 pattern="^[0-9]*$"
                 autocomplete="one-time-code"
                 inputmode="numeric" />
        </div>

        @if (codeRef.invalid && (codeRef.dirty || codeRef.touched)) {
          @if (codeRef.errors?.['required']) {
            <div class="text-danger">Code is required.</div>
          }
          @if (codeRef.errors?.['minlength']) {
            <div class="text-danger">Minimum length is 6 digits.</div>
          }
          @if (codeRef.errors?.['pattern']) {
            <div class="text-danger">Only numbers are allowed.</div>
          }
        }

        <button [class.disabled]="codeRef.invalid"
                [disabled]="submitting() || codeRef.invalid"
                (click)="verify()"
                class="common-btn mt-4"
                type="submit">
          @if (submitting()) {
            <img class="loading-img" src="assets/images/processing_white.svg" />
          } @else {
            Verify
          }
        </button>

        <p>
          <a class="cursor-pointer"
             (click)="sendCode(true)"
             [class.text-muted]="resendCooldown() || resending()"
             [style.pointerEvents]="resendCooldown() || resending() ? 'none' : 'auto'"
             [attr.aria-disabled]="resendCooldown() || resending()">
            {{ resendCooldown() ? 'Resend code after ' + resendCountdown() + 's' : 'Resend Code' }}
          </a>
        </p>
      </form>
    </div>
  }
</div>
